/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryTokenCompetition } from './EntryTokenCompetition';
import {
    EntryTokenCompetitionFromJSON,
    EntryTokenCompetitionFromJSONTyped,
    EntryTokenCompetitionToJSON,
    EntryTokenCompetitionToJSONTyped,
} from './EntryTokenCompetition';

/**
 * 
 * @export
 * @interface EntryTokenGroup
 */
export interface EntryTokenGroup {
    /**
     * 
     * @type {string}
     * @memberof EntryTokenGroup
     */
    nftTrackerId: string;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenGroup
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntryTokenGroup
     */
    isBadge: boolean;
    /**
     * How many un-consumed tokens of this type the caller holds.
     * @type {number}
     * @memberof EntryTokenGroup
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof EntryTokenGroup
     */
    tokenImageUrl?: string;
    /**
     * OPEN competitions accepting this token type. Empty when none are open; the player still holds the token.
     * @type {Array<EntryTokenCompetition>}
     * @memberof EntryTokenGroup
     */
    competitions: Array<EntryTokenCompetition>;
}

/**
 * Check if a given object implements the EntryTokenGroup interface.
 */
export function instanceOfEntryTokenGroup(value: object): value is EntryTokenGroup {
    if (!('nftTrackerId' in value) || value['nftTrackerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isBadge' in value) || value['isBadge'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('competitions' in value) || value['competitions'] === undefined) return false;
    return true;
}

export function EntryTokenGroupFromJSON(json: any): EntryTokenGroup {
    return EntryTokenGroupFromJSONTyped(json, false);
}

export function EntryTokenGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryTokenGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'nftTrackerId': json['nftTrackerId'],
        'name': json['name'],
        'isBadge': json['isBadge'],
        'count': json['count'],
        'tokenImageUrl': json['tokenImageUrl'] == null ? undefined : json['tokenImageUrl'],
        'competitions': ((json['competitions'] as Array<any>).map(EntryTokenCompetitionFromJSON)),
    };
}

export function EntryTokenGroupToJSON(json: any): EntryTokenGroup {
    return EntryTokenGroupToJSONTyped(json, false);
}

export function EntryTokenGroupToJSONTyped(value?: EntryTokenGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftTrackerId': value['nftTrackerId'],
        'name': value['name'],
        'isBadge': value['isBadge'],
        'count': value['count'],
        'tokenImageUrl': value['tokenImageUrl'],
        'competitions': ((value['competitions'] as Array<any>).map(EntryTokenCompetitionToJSON)),
    };
}

